import {useRef, useState} from "react";
import style from './Login.module.css';

export default function Login(props: {setUser: (user: string|undefined) => void}) {

    const usernameRef = useRef<HTMLInputElement>(null);
    const [usernameError, setUsernameError] = useState<boolean|undefined>(undefined);

    const onUsernameSet = () => {
        props.setUser(usernameRef.current?.value);
    }

    const onUsernameChange = (e: { target: { value: string; }; }) => {
        const value = e.target.value;
        setUsernameError(value && value.length > 0 ? !value.match(/^[0-9a-zA-Z]{1,7}$/) : undefined);
    }

    return (
        <div className="bg-white/50 shadow-lg border
        w-screen h-screen max-w-lg max-h-96">
            <div className="w-full h-full relative grid place-items-center">
                <h1 className={`absolute left-6 top-4 ${style.logo}`}>Dumberg</h1>
                <div className="w-80">
                    <h2 className={`text-center text-xl ${style.signInTitle}`}>Sign in</h2>
                    <h3 className="leading-7 text-sm text-center">Please enter a username to sign in.</h3>
                    <div className="w-full">
                        <input
                            className={`px-2 py-3 my-6 border rounded w-full
                            ${usernameError ? 'border-red-500 outline-red-500' : 'border-gray-300'}`}
                            ref={usernameRef}
                            type="text"
                            placeholder="Enter a username*"
                            onChange={onUsernameChange}
                        />
                    </div>
                    <div className="w-full">
                        <button
                            className="px-2 py-2 bg-black text-white text-sm font-bold w-full
                            hover:text-gray-400 hover:bg-gray-900"
                            onClick={onUsernameSet}
                            disabled={usernameError || usernameError === undefined}
                        >
                            Continue
                        </button>
                    </div>
                </div>
                <p className="absolute right-6 bottom-4 text-xs text-gray-900">
                    *Max 6 characters, only alphanumeric
                </p>
            </div>
        </div>
    );

}